export const replaceArr = [{old: 'passenger_order_interval', new: 'price_range'}, {
    old: 'form_of_cooperation', new: 'cooperate_mode'
}, {new: 'customer_alias', old: 'customer_name_custom'}]
